import React, {useState} from 'react';
import {Dropdown, Form} from "react-bootstrap";
import CreateCategoryForm from "./createCategoryForm";

const DropDownCategory = ({categories,somthingWithCategory, table}) => {
  const addToCategory = (id,name) =>{
    if(window.confirm(`Добавить ${table.name} в ${name}?`)){
      somthingWithCategory({id,
        child:table.name,
        deletion: false})
    }
  }
  return (
    <Dropdown>
      <Dropdown.Toggle variant={'link'}
                       id="dropdown-basic"
                       drop={'end'}
                       style={{padding:'0px 6px 0px 0px', color:'black'}}>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <CreateCategoryForm somthingWithCategory={somthingWithCategory} child={table.name}/>
        {categories.map((cat, index)=>{
          return <Dropdown.Item key={index} onClick={()=>{addToCategory(cat.value,cat.label)}}>{cat.label}</Dropdown.Item>
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropDownCategory;
